import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import Confirmation from '~/pages/Confirmation';

const CONFIRMATION_ROUTES: RouteObject[] = [
  {
    path: PATH.CONFIRMATION,
    element: <Confirmation />,
  },
];

export { CONFIRMATION_ROUTES };
